module.exports = __webpack_public_path__ + "img/background_principal_pc900.b84708cb.webp";